// extracted by mini-css-extract-plugin
export var box = "_7c-1";
export var checkboxRow = "_7c-8";
export var checked = "_7c-2";
export var descriptionSpacer = "_7c-a";
export var disabled = "_7c-3";
export var icon = "_7c-6";
export var input = "_7c-0";
export var labelSpacer = "_7c-9";
export var medium = "_7c-5";
export var small = "_7c-4";
export var text = "_7c-7";